// extracted by extract-css-chunks-webpack-plugin
module.exports = {"positive":"Button__positive--23dBE","negative":"Button__negative--1o6oq","active":"Button__active--33NUW","inactive":"Button__inactive--1zsH6"};